import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 存储token
    authorization: localStorage.getItem('authorization')
      ? localStorage.getItem('authorization')
      : '',
    loginUser: {
      userName: localStorage.getItem('userName')
        ? localStorage.getItem('userName')
        : '',
      userAccount: localStorage.getItem('userAccount')
        ? localStorage.getItem('userAccount')
        : '',
      userPkid: localStorage.getItem('userPkid')
        ? localStorage.getItem('userPkid')
        : '',
      loginTenantName: localStorage.getItem('loginTenantName')
        ? localStorage.getItem('loginTenantName')
        : ''
    }
  },
  mutations: {
    setLoginUser (state, userInfo) {
      state.loginUser = userInfo
      state.authorization = userInfo.authorization
      localStorage.setItem('userName', userInfo.userName)
      localStorage.setItem('userAccount', userInfo.userAccount)
      localStorage.setItem('userPkid', userInfo.userPkid)
      localStorage.setItem('loginTenantName', userInfo.loginTenantName || '')
      localStorage.setItem('authorization', userInfo.authorization)
    }
  },
  actions: {},
  modules: {}
})
